const Calculate = (v:any, prop:any) => {

  const eMultiplier = 4

  v.eConsumptionJaw.value = v.dieselConsumptionJaw.value * eMultiplier
  v.eConsumptionCone.value = v.dieselConsumptionCone.value * eMultiplier
  v.eConsumptionScreen.value = v.dieselConsumptionScreen.value * eMultiplier
  v.eConsumptionTotal.value = v.eConsumptionJaw.value + v.eConsumptionCone.value + v.eConsumptionScreen.value
  v.dieselConsumptionTotal.value = v.dieselConsumptionJaw.value + v.dieselConsumptionCone.value + v.dieselConsumptionScreen.value

  v.dieselCostPerHour.value = v.dieselConsumptionTotal.value * v.dieselPrice.value
  v.eCostPerHour.value = v.eConsumptionTotal.value * v.ePrice.value

  v.yearlyHours.value = v.weeklyHours.value * 50

  v.dieselCostPerYear.value = v.yearlyHours.value * v.dieselCostPerHour.value
  v.eCostPerYear.value = v.yearlyHours.value * v.eCostPerHour.value

  v.capacityPerYear.value = v.capacity.value * v.yearlyHours.value

  v.dieselCostPerTon.value = v.dieselCostPerYear.value / v.capacityPerYear.value
  v.eCostPerTon.value = v.eCostPerYear.value / v.capacityPerYear.value

  v.dieselCO2Jaw.value = v.dieselConsumptionJaw.value * v.dieselCO2Emission.value
  v.dieselCO2Cone.value = v.dieselConsumptionCone.value * v.dieselCO2Emission.value
  v.dieselCO2Screen.value = v.dieselConsumptionScreen.value * v.dieselCO2Emission.value
  v.dieselCO2Total.value = v.dieselConsumptionTotal.value * v.dieselCO2Emission.value

  v.eCO2Jaw.value = v.eConsumptionJaw.value * v.eCO2Emission.value
  v.eCO2Cone.value = v.eConsumptionCone.value * v.eCO2Emission.value
  v.eCO2Screen.value = v.eConsumptionScreen.value * v.eCO2Emission.value
  v.eCO2Total.value = v.eConsumptionTotal.value * v.eCO2Emission.value

  v.savingsCO2Total.value = v.dieselCO2Total.value * v.yearlyHours.value - v.eCO2Total.value * v.yearlyHours.value
  v.savingsTotal.value = v.dieselCostPerYear.value - v.eCostPerYear.value

  return v

}

export default Calculate